import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  serviceArea: [],
  areaPoints: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
